function dummy(t: (val: string) => string) {
  const dataUnit = [
    {
      id: 1,
      label: t('workload_landing.unit_label_2'),
      value: 'minute',
    },
    {
      id: 2,
      label: t('workload_landing.unit_label_3'),
      value: 'hour',
    },
  ];
  return { dataUnit };
}

export default dummy;
